// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__1py-W","hoverable":"card_hoverable__2iCid"};